module.exports = __webpack_public_path__ + "static/media/check.12c0f924.svg";